<div [ngClass]="RightOverlay==false?'generalPage highlightSearchTerm_PCS' :'archive-margin-main'">
  <div class="ptb-archive " *ngIf="!RightOverlay">
    <div class="flex-display">
      <div class="cursor-pointer">
        <img src="../../../../assets/icons/Pending.svg" class="pending-image" alt="alarm">
      </div>
      <div class="PendingContent-general-header">
        {{sectionHeader}}
      </div>
      <div class="text-align-right singleLine">
        <div class="cursor-pointer ">
          <span>
            <a class="anchor-black">Edit</a>
            <img src="../../../../assets/icons/pencil.svg" class="pencil-iconwidth" alt="alarm">
          </span>
          <span class="ml-2"> <a class="anchor-black">Reset</a></span>
        </div>
      </div>
    </div>
    <div class="ml-2 flex-display">
      <div class="archive-btn">
        <span class="archive-Info mr-14px">{{showingContent_Label}} {{FiscalDate}}</span>
        <span class="archive-Info mr-14px">{{fillingStatus_Label}}:{{fillingStatus}}</span>
        <span class="archive-Info mr-14px">{{periodTypeLabel}}:{{PeriodType}}</span>

      </div>
    </div>
  </div>
  <div [ngClass]="RightOverlay==false?'padding-archive-screen' :''">
    <div class="mb-1">
    <app-breadcrumbs-path  hidden *ngIf="RightOverlay" [crumbData]="navData.crumbData"></app-breadcrumbs-path></div>
    <div hidden class="mb-2">
      <h1 id="pageHeading" role="main" class="pcsHeader" [innerHTML]="pageHeading">
      </h1>
    </div>
    <div hidden class="componentHeader topicHeader" *ngIf="RightOverlay">
      <span [innerHTML]="topicBodyContent"></span>
    </div>
    <div class="text-align-center font-20" *ngIf="!validPendingData">No data found</div>
    <div *ngFor="let para of paragraphTitleContent">
      <div tabindex="0" *ngIf="para.headingName.topicTitleName != ''">
        <div [id]="para.headingName.topicTitleId">
          <h2 class="paraHeader">
            <span [innerHTML]="para.headingName.topicTitleName"></span>
          </h2>
        </div>
      </div>

      <div *ngFor="let paragraph of para.paragraphContent">
        <div *ngIf=" paragraph.paraNum == PendingContentParagraph">
          <div class="mt_1 width-90" *ngIf="paragraph.paragroup != ''">
            <div class="mt_1" [ngClass]="paragraph.paraTitle == null?'mb-1':'mb-1'">
              <h3 class="topicHeader" tabindex="0">
                <span>>&nbsp;</span><span [innerHTML]="paragraph.paragroup"></span>
              </h3>
            </div>
          </div>
          <pub-dita-content [id]="paragraph.id" [dita]="paragraph.paraContent" [s3ImageBasePath]="s3ImageBasePath" [paraTitle]="paragraph.paraTitle" [paraTitle2]="paragraph.paraTitle2" [paraTitle3]="paragraph.paraTitle3" [paraTitle4]="paragraph.paraTitle4" [paraTitle5]="paragraph.paraTitle5" (eventemit)="eventHandler()" [PendingContentPage]="!RightOverlay" [PendingContentMerge]="PendingContentMergeList" [UserInfo]="loggedInUserInfo" [paraNum]="topic_subtopicNum + paragraph.paraNum" [topic_subtopicNum]="topic_subtopicNum"></pub-dita-content>
        </div>
      </div>
    </div>
    <div class="box"></div>
  </div>
</div>
